import { useNavigate } from "react-router-dom";

export default function TagList({ tags, filterType }) {
  const navigate = useNavigate();

  function handleTagClick(name) {
    navigate(`/?${filterType}=${encodeURIComponent(name)}`);
  }

  return tags.map((name, idx) => (
    <span key={name}>
      <button
        onClick={() => handleTagClick(name)}
        className="text-stone-400 underline decoration-stone-400 hover:text-stone-300 hover:decoration-stone-300 transition-colors cursor-pointer"
      >
        {name}
      </button>
      {idx < tags.length - 1 && ", "}
    </span>
  ));
}
